var React = require('react');

function InlineSvg (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"40","cy":"40","r":"40","fill":"#DD0000","fillOpacity":"0.08","key":0}),React.createElement("circle",{"cx":"40","cy":"40","r":"16","fill":"#DD0000","key":1}),React.createElement("path",{"d":"M45 40C45 37.2386 42.7614 35 40 35C37.2386 35 35 37.2386 35 40C35 42.7614 37.2386 45 40 45V47C36.134 47 33 43.866 33 40C33 36.134 36.134 33 40 33C43.866 33 47 36.134 47 40C47 43.866 43.866 47 40 47V45C42.7614 45 45 42.7614 45 40Z","fill":"white","key":2}),React.createElement("rect",{"x":"35.0801","y":"36.4936","width":"2","height":"11.8635","transform":"rotate(-45 35.0801 36.4936)","fill":"white","key":3})]);
}

InlineSvg.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = InlineSvg;

InlineSvg.default = InlineSvg;
